export class AiProcessStepsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiProcessSteps({ aiProcessId, ...params }) {
    return this.#http.get(`/api/ai-processes/${aiProcessId}/steps`, {
      params,
      paramsSerializer: { indexes: null },
    });
  }

  async getAiProcessStepById({ aiProcessId, id }) {
    return this.#http.get(`/api/ai-processes/${aiProcessId}/steps/${id}`);
  }

  async createAiProcessStep({ aiProcessId, id, ...body }) {
    return this.#http.post(`/api/ai-processes/${aiProcessId}/steps`, body);
  }

  async updateAiProcessStep({ aiProcessId, id, ...body }) {
    return this.#http.put(`/api/ai-processes/${aiProcessId}/steps/${id}`, body);
  }

  async deleteAiProcessStep({ aiProcessId, id }) {
    return this.#http.delete(`/api/ai-processes/${aiProcessId}/steps/${id}`);
  }

  async getAiProcessStepsTools(scopeKind) {
    return this.#http.get(`/api/ai-processes/available-tools`, { params: { scopeKind } });
  }

  async getAiProcessStepsResources(scopeKind) {
    return this.#http.get(`/api/ai-processes/available-resources`, { params: { scopeKind } });
  }

  async updateAiProcessStepOrder(aiProcessId, body) {
    return this.#http.put(`/api/ai-processes/${aiProcessId}/steps/order`, body);
  }
}
